// src/Screens/Components/Input.tsx

import React from 'react';
import { cn } from '../../utils/cn';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  sublabel?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, sublabel, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-2xl font-normal text-gray-900 mb-2">
            {label}
          </label>
        )}
        {sublabel && (
          <p className="text-base mb-4">{sublabel}</p>
        )}
        <input
          type={type}
          className={cn(
            'block w-full px-4 py-3 text-lg bg-transparent border-b-2 focus:border-indigo-500 focus:outline-none transition-colors duration-200',
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };
